// Generated by CoffeeScript 1.7.1
module.exports = function(string, size, options) {
  var escapecolor, i, pad, prefix, _i, _ref;
  if (options == null) {
    options = {};
  }
  prefix = typeof string === 'number';
  if (prefix) {
    _ref = [string, size], size = _ref[0], string = _ref[1];
  }
  if (typeof options === 'string') {
    options = {
      char: options
    };
  }
  if (options.char == null) {
    options.char = ' ';
  }
  string = string.toString();
  pad = '';
  if (options.colors) {
    escapecolor = /\x1B\[([0-9]{1,2}(;[0-9]{1,2})?)?[m|K]/g;
    size += string.length - string.replace(escapecolor, '').length;
  }
  size = size - string.length;
  for (i = _i = 0; 0 <= size ? _i < size : _i > size; i = 0 <= size ? ++_i : --_i) {
    pad += options.char;
  }
  if (prefix) {
    return pad + string;
  } else {
    return string + pad;
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/pad/lib/index.js
 ** module id = 269
 ** module chunks = 46 47
 **/